import { eventChannel, END } from 'redux-saga';

const zoom = () => {
  return eventChannel((emit) => {
    window.Hover.Machete.viewer.controls.addEventListener('zoom', emit);

    return () => {
      window.Hover.Machete.viewer.controls.removeEventListener('zoom', emit);
    };
  });
};

const rotate = () => {
  return eventChannel((emit) => {
    window.Hover.Machete.viewer.controls.addEventListener('rotate', emit);

    return () => {
      window.Hover.Machete.viewer.controls.removeEventListener('rotate', emit);
    };
  });
};

function secondRapidClick() {
  return eventChannel((emit) => {
    const failSecondRapidClickCatch = () => {
      window.clearTimeout(failSecondRapidClickCatch);
      emit(false);
      emit(END);
    };

    const caughtSecondRapidClick = () => {
      window.clearTimeout(failSecondRapidClickCatch);
      emit(true);
      emit(END);
    };

    document.addEventListener('pointerdown', caughtSecondRapidClick);

    window.setTimeout(failSecondRapidClickCatch, 300);

    return () => {
      document.removeEventListener('pointerdown', caughtSecondRapidClick);
    };
  });
}

export default {
  rotate,
  secondRapidClick,
  zoom,
};
